import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00293 = new TileLayer({
  title: 'Máscara 20010901',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20010901l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00293.setVisible(false);

const layer00292 = new TileLayer({
  title: 'Máscara 20020224',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020224l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00292.setVisible(false);

const layer00291 = new TileLayer({
  title: 'Máscara 20020429',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020429l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00291.setVisible(false);

const layer00290 = new TileLayer({
  title: 'Máscara 20020616',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020616l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00290.setVisible(false);

const layer00289 = new TileLayer({
  title: 'Máscara 20020624',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020624l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00289.setVisible(false);

const layer00288 = new TileLayer({
  title: 'Máscara 20020702',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020702l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00288.setVisible(false);

const layer00287 = new TileLayer({
  title: 'Máscara 20020718',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20020718l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00287.setVisible(false);

export const grupoCapa01_20 = new LayerGroup({
  title: 'Ciclo Hidrológico 2001-2002',
  fold: 'close',
  layers: [layer00287, layer00288, layer00289, layer00290, layer00291, layer00292, layer00293]
});